import _extends from '@babel/runtime-corejs3/helpers/extends';
import React from 'react';

var CircleTick = function CircleTick(props) {
  return /*#__PURE__*/React.createElement("path", _extends({}, props, {
    d: "M10.25 15.06l7.88-8.12c.2-.2.51-.2.7 0l.73.7c.2.18.2.5 0 .7l-8.6 8.86a1 1 0 01-1.43 0l-4.1-4.23a.5.5 0 01.01-.7l.72-.7a.5.5 0 01.7.01l3.39 3.48z"
  }));
};
var CircleSolid = function CircleSolid(props) {
  return /*#__PURE__*/React.createElement("path", _extends({}, props, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24a12 12 0 100-24 12 12 0 000 24z"
  }));
};
var CircleBorder = function CircleBorder(props) {
  return /*#__PURE__*/React.createElement("path", _extends({}, props, {
    d: "M23.25 12a11.25 11.25 0 11-22.5 0 11.25 11.25 0 0122.5 0z"
  }));
};
var SquareTick = function SquareTick(props) {
  return /*#__PURE__*/React.createElement("path", _extends({}, props, {
    d: "M10.16 15.48l7.88-8.12c.2-.2.51-.2.71-.01l.72.7c.2.19.2.5.01.7l-8.6 8.86a1 1 0 01-1.43 0l-4.1-4.22a.5.5 0 010-.7l.73-.7a.5.5 0 01.7 0l3.38 3.49z"
  }));
};
var SquareSolid = function SquareSolid(props) {
  return /*#__PURE__*/React.createElement("rect", _extends({}, props, {
    x: "1",
    y: "1",
    width: "22",
    height: "22",
    rx: "2"
  }));
};
var SquareBorder = function SquareBorder(props) {
  return /*#__PURE__*/React.createElement("rect", _extends({}, props, {
    x: "1.75",
    y: "1.75",
    width: "20.5",
    height: "20.5",
    rx: "1.25"
  }));
};

export { CircleBorder, CircleSolid, CircleTick, SquareBorder, SquareSolid, SquareTick };
//# sourceMappingURL=TUXCheckboxIcon.js.map
